import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'underscore';

import * as questionActions from '../../actions/questions';
import ResponsesManager from '../questions/responsesManager'
import { FocusPointsInputAndConceptSelectorForm, } from '../../../Shared/index';

class NewFocusPointsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmitFocusPointForm = this.handleSubmitFocusPointForm.bind(this);
  }

  getFocusPoints() {
    const { questions, match, } = this.props
    return questions.data[match.params.questionID].focusPoints;
  }

  handleSubmitFocusPointForm(data) {
    const { dispatch, match, history } = this.props
    if (data.conceptResults && data.conceptResults.null !== undefined) {
      delete data.conceptResults.null;
    }
    data.order = _.keys(this.getFocusPoints()).length + 1;
    dispatch(questionActions.submitNewFocusPoint(match.params.questionID, data, () => {
      // Navigate directly to the focus points list page instead of going back
      history.push(`/admin/questions/${match.params.questionID}/focus-points`);
    }));
  }

  render() {
    const { children, match, questions, } = this.props
    return (
      <div>
        <FocusPointsInputAndConceptSelectorForm
          itemLabel="Focus Point"
          onSubmit={this.handleSubmitFocusPointForm}
          questionID={match.params.questionID}
          questions={questions}
          ResponsesManager={ResponsesManager}
        />
        {children}
      </div>
    );
  }
}

function select(props) {
  const { questions, } = props
  return {
    questions: questions,
  }
}

export default withRouter(connect(select)(NewFocusPointsContainer));
